import { Link } from "react-router-dom";
import { DateTime } from "luxon";

//Assets
import { ReactComponent as CicleLink } from "../../assets/img/circle-link.svg";

const NewsItem = ({ id, slug, title, image, date, project, animationDelay, styleClass }) => {
	return (
		<Link to={`/news/${slug}`} state={{ newsArticleId: id }} className={`projectItem project-reveal ${styleClass}`} style={{ animationDelay: `${animationDelay}ms` }}>
			<img src={`${image}?w=500`} alt={`Thumbnail for ${title}`} />
			<div className="flex jContent-spaceBetween aItems-end padding-small projectItem-titleWrapper">
				<div className="title">
					<div className="subTitle fontSize-small fontColour-lighter flex gap-small">
						<span>{DateTime.fromISO(date).toFormat("dd MMM yyyy")}</span>
						{project && (
							<>
								<span>//</span>
								<span>{project.title}</span>
							</>
						)}
					</div>
					<span className="limitLines-1">{title}</span>
				</div>
				<div className="projectItem-link aSelf-center fontSize-medium">
					<i className="bi bi-arrow-right-short"></i>
				</div>
				{/* <CicleLink /> */}
			</div>
		</Link>
	);
};

export default NewsItem;
